import { PageWorkflowStatus } from 'shared/types/global'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'

import PageStatusSelect from '../PageStatusSelect'

type ContentPageInfoProps = {
  number: number
  title: string
  status: PageWorkflowStatus
  onStatusChange: (status: PageWorkflowStatus) => void
  onStatusOpenChange: (isOpen: boolean) => void
}

const ContentPageInfo: React.FC<ContentPageInfoProps> = ({
  number,
  title,
  status,
  onStatusChange,
  onStatusOpenChange
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      paddingLeft={4}
    >
      <Text
        size={12}
        weight={600}
        text={number.toString()}
        color={theme => theme.color.base.c7}
      />

      <Text
        marginRight={4}
        text={title}
        size={12}
        color={theme => theme.color.base.c6}
      />

      <PageStatusSelect
        status={status}
        onChange={onStatusChange}
        onOpenChange={onStatusOpenChange}
      />
    </Flex>
  )
}

export default ContentPageInfo
